// Takes rows from vw_supply_plan_values (one row per location-program-sku)
// and groups them into one object per location-program combination
const groupForecastRows = forecasts => {
  const byKey = forecasts.reduce((byKey, forecast) => {
    const key = `${forecast.location}:${forecast.program}`
    byKey[key] = byKey[key] || {
      locationId: forecast.location,
      program: forecast.program,
      dailyDemand: {},
      safetyStock: {},
      minLevel: {},
      reorderPoint: {},
      maxLevel: {}
    }
    byKey[key].dailyDemand[forecast.sku] = Number(forecast.daily_forecast)
    byKey[key].safetyStock[forecast.sku] = Number(forecast.safety_stock)
    byKey[key].minLevel[forecast.sku] = Number(forecast.min_level)
    byKey[key].reorderPoint[forecast.sku] = Number(forecast.reorder_point)
    byKey[key].maxLevel[forecast.sku] = Number(forecast.max_level)
    return byKey
  }, {})

  return Object.values(byKey)
}

const toProductLevels = forecast =>
  Object.keys(forecast.dailyDemand).reduce((acc, sku) => {
    acc[sku] = {
      min: forecast.minLevel[sku],
      reorderPoint: forecast.reorderPoint[sku],
      max: forecast.maxLevel[sku],
      dailyForecast: forecast.dailyDemand[sku]
    }
    return acc
  }, {})

module.exports = { groupForecastRows, toProductLevels }
